import { changeLanguage } from 'i18next';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router';

import { usePlaymakersOptions } from '../store';

import GoogleTagManagerHelper from '@tracking/gtm-helper';
import { IS_DEBUG } from '@utilities/browser';

const addPageMeta = (language) => {
  GoogleTagManagerHelper.addPageMeta({
    pageName: location.pathname,
    language,
    pageLanguage: language,
  });
};

const defaultLocale = 'en';

const LanguageManager = () => {
  const {
    options: { acceptedLanguages },
  } = usePlaymakersOptions();
  const { i18n } = useTranslation();
  const { locale } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const lang = acceptedLanguages.includes(locale) ? (locale ?? defaultLocale) : defaultLocale;

    if (i18n.language !== lang) {
      changeLanguage(lang);
      addPageMeta(lang.toUpperCase());
    }
  }, [acceptedLanguages, i18n, locale]);

  useEffect(() => {
    if (locale && acceptedLanguages.includes(locale)) return;
    navigate(`/${defaultLocale}/`);
  }, [acceptedLanguages, navigate, i18n.language, locale]);

  if (IS_DEBUG) {
    return (
      <>
        <div>locale: {locale}</div>
        <div>language: {i18n.language}</div>
      </>
    );
  }

  return null;
};

export default LanguageManager;
